"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var TMobile = function TMobile(props) {
  var color = props.color,
      size = props.size,
      others = _objectWithoutPropertiesLoose(props, ["color", "size"]);

  return _react.default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 24 24"
  }, others), _react.default.createElement("path", {
    d: "M2.342 0l-.26 8.52 1.3.196c.26-2.537.91-4.358 1.951-5.594C6.44 1.887 8.001 1.17 10.017 1.105v17.757c0 1.56-.195 2.536-.65 2.991-.39.39-1.041.65-1.952.715-.26 0-.716.066-1.366.066V24H17.95v-1.366c-.65 0-1.105 0-1.365-.066-.91-.065-1.561-.325-1.951-.715-.456-.455-.65-1.496-.65-2.991V1.172c2.015.064 3.576.714 4.682 2.015 1.105 1.236 1.756 3.057 1.95 5.593l1.302-.195L21.593 0zm-.26 11.057v4.878h4.877v-4.878H4.62zm14.894 0v4.878h4.878v-4.878h-2.081z"
  }));
};

TMobile.propTypes = {
  /**
   * Hex color or color name
   */
  color: _propTypes.default.string,

  /**
   * The size of the Icon.
   */
  size: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
TMobile.defaultProps = {
  color: 'currentColor',
  size: '24'
};
var _default = TMobile;
exports.default = _default;